import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

const BITRIX_BASE_URL = process.env.REACT_APP_BITRIX_BASE_URL || 'https://vedmarket.bitrix24.ru/rest/18/yaylnikdkqmz0gkg';

export const bitrixApi = createApi({
  reducerPath: 'bitrixApi',
  baseQuery: fetchBaseQuery({ baseUrl: BITRIX_BASE_URL }),
  endpoints: (builder) => ({
    getLeadByEmail: builder.mutation<BitrixLeadOutput, BitrixLeadInput>({
      query: (body) => ({ url: `crm.lead.list.json`, method: 'POST', body}),
    }),
    updateLeadStatus: builder.mutation<BitrixUpdateLeadStatusOutput, BitrixUpdateLeadStatusInput>({
      query: (body) => ({ url: `crm.lead.update.json`, method: 'POST', body}),
    }),
    createLeadByEmail: builder.mutation<BitrixCreateLeadOutput, BitrixCreateLeadInput>({
      query: (body) => ({ url: `crm.lead.add.json`, method: 'POST', body }),
    }),
  }),
});

export const useGetLeadByEmailMutation = () => {
  return bitrixApi.useGetLeadByEmailMutation({ fixedCacheKey: 'getLeadByEmail' })
}

export const useUpdateLeadStatusMutation = () => {
  return bitrixApi.useUpdateLeadStatusMutation({ fixedCacheKey: 'updateLeadStatus' })
}

export const useCreateLeadByEmailMutation = () => {
  return bitrixApi.useCreateLeadByEmailMutation({ fixedCacheKey: 'createLeadByEmail' })
}
